import React from 'react';
import { Responsive, WidthProvider, Layouts } from 'react-grid-layout';
import SummaryCount from '../../../../components/common/summary-count/SummaryCount';
import { useSelector } from 'react-redux';
import { selectRunLifeSummary } from '../../RunlifeDarshboardSlice';

const ResponsiveGridLayout = WidthProvider(Responsive);
export enum RunLifeSummaryKeys {
  TotalWells = 'TotalWells',
  TotalInstallations = 'TotalInstallations',
  TotalRunningUnits = 'TotalRunningUnits',
  TotalFailures = 'TotalFailures',
  TotalFailuresWithinDays = 'TotalFailuresWithinDays',
  TotalPulls = 'TotalPulls',
  AverageRunlife = 'AverageRunlife',
  AverageRunlifeRunningUnits = 'AverageRunlifeRunningUnits',
  AverageRunlifeFailedUnits = 'AverageRunlifeFailedUnits',
}
export type RulLifeSummaryKey = keyof typeof RunLifeSummaryKeys;

const data = [
  { key: RunLifeSummaryKeys.TotalWells, title: 'Wells', color: '#00789E' },
  { key: RunLifeSummaryKeys.TotalInstallations, title: 'Installs', color: '#00789E' },
  { key: RunLifeSummaryKeys.TotalRunningUnits, title: 'Running', color: '#00A17B' },
  { key: RunLifeSummaryKeys.TotalFailures, title: 'Failed', color: '#F04438' },
  { key: RunLifeSummaryKeys.TotalFailuresWithinDays, title: 'Failed < 90', color: '#F04438' },
  { key: RunLifeSummaryKeys.TotalPulls, title: 'Pulled (NF)', color: '#00789E' },
  { key: RunLifeSummaryKeys.AverageRunlife, title: 'Average runlife', color: '#00789E', showDays: true },
  {
    key: RunLifeSummaryKeys.AverageRunlifeRunningUnits,
    title: 'Average runlife running',
    color: '#00A17B',
    showDays: true,
  },
  {
    key: RunLifeSummaryKeys.AverageRunlifeFailedUnits,
    title: 'Average runlife failed',
    color: '#F04438',
    showDays: true,
  },
];
const layouts: Layouts = {
  md: [
    { i: RunLifeSummaryKeys.TotalWells, x: 0, y: 0, w: 2, h: 1 },
    { i: RunLifeSummaryKeys.TotalInstallations, x: 2, y: 0, w: 2, h: 1 },
    { i: RunLifeSummaryKeys.TotalRunningUnits, x: 4, y: 0, w: 2, h: 1 },
    { i: RunLifeSummaryKeys.TotalFailures, x: 6, y: 0, w: 2, h: 1 },
    { i: RunLifeSummaryKeys.TotalFailuresWithinDays, x: 8, y: 0, w: 2, h: 1 },
    { i: RunLifeSummaryKeys.TotalPulls, x: 10, y: 0, w: 2, h: 1 },
    { i: RunLifeSummaryKeys.AverageRunlife, x: 0, y: 1, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.AverageRunlifeRunningUnits, x: 4, y: 1, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.AverageRunlifeFailedUnits, x: 8, y: 1, w: 4, h: 1 },
  ],
  sm: [
    { i: RunLifeSummaryKeys.TotalWells, x: 0, y: 0, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.TotalInstallations, x: 4, y: 0, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.TotalRunningUnits, x: 8, y: 0, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.TotalFailures, x: 0, y: 1, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.TotalFailuresWithinDays, x: 4, y: 1, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.TotalPulls, x: 8, y: 1, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.AverageRunlife, x: 0, y: 2, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.AverageRunlifeRunningUnits, x: 4, y: 2, w: 4, h: 1 },
    { i: RunLifeSummaryKeys.AverageRunlifeFailedUnits, x: 8, y: 2, w: 4, h: 1 },
  ],
};
const RealLifeSummary: React.FC = () => {
  const counts = useSelector(selectRunLifeSummary);

  return (
    <ResponsiveGridLayout
      layouts={layouts}
      breakpoints={{ md: 800, sm: 799 }}
      cols={{ md: 12, sm: 12 }}
      rowHeight={105}
      isDraggable={false}
      isResizable={false}
      margin={[20, 16]}
    >
      {data.map((item) => (
        <div key={item.key}>
          <SummaryCount
            key={item.key}
            gridKey={item.key}
            title={item.title}
            count={counts?.[item.key as RulLifeSummaryKey] || 0}
            color={item.color}
            showDays={item.showDays}
          />
        </div>
      ))}
    </ResponsiveGridLayout>
  );
};
export default RealLifeSummary;
